<ion-button (click)="toggleMenu()">
  <ion-icon name="menu" slot="icon-only"></ion-icon>
</ion-button>
